import React from "react";
import VWSpinner from "../vwSpinner/vwSpinner";

const VWLoading = (props) => {
    const { width, height } = props;
    return (
        <div>
            <div className="d-flex justify-content-center align-items-center">
                {(width || height) ? <VWSpinner height={40} width={40} /> : <VWSpinner />}
            </div>
            <div className="d-grid justify-content-center align-items-center">
                <div className="text-center fw-bold pt-3 fs-6">Please wait while processing your request</div>
            </div>
        </div>
    )
}

export default VWLoading;